import { type BoxProps, HStack, Text, VStack } from '@chakra-ui/react';
import { DisplayCard } from '@ui/components/Input/DisplayCard';
import PreciseNum from '@ui/components/Num/PreciseNum';
import { UsdValue } from '@ui/components/Num/UsdValue';
import type { TokenConfig } from '@ui/config/token';
import { type Fraction, RoundingMode } from 'bi-fraction';
import type { ReactNode } from 'react';

interface ToTokenCardProps extends BoxProps {
  toTokenAmount: Fraction | undefined;
  toTokenInfo: TokenConfig | undefined;
  toTokenPrice: Fraction | undefined;
  toTokenBalance: Fraction | undefined;
  tokenSelector: ReactNode;
}

export const ToTokenCard = ({
  toTokenAmount,
  toTokenInfo,
  toTokenPrice,
  toTokenBalance,
  tokenSelector,
  ...props
}: ToTokenCardProps) => {
  return (
    <>
      <DisplayCard
        readOnly
        usd={<UsdValue value={toTokenAmount} price={toTokenPrice} />}
        tokenSelector={tokenSelector}
        {...props}
      >
        <PreciseNum
          value={toTokenAmount}
          wordBreak="break-all"
          decimalPlaces={toTokenInfo?.displayDecimals}
          roundingMode={RoundingMode.ROUND_DOWN}
          removeSignificantTrailingZeros={true}
        />
      </DisplayCard>
      <HStack align="flex-start" mt="8px">
        <Text textStyle="body2" mr="auto">
          Balance
        </Text>
        <VStack gap={0.5} alignItems="flex-end">
          <HStack>
            <PreciseNum
              decimalPlaces={toTokenInfo?.displayDecimals}
              value={toTokenBalance}
              textStyle="body2Bold"
              lineClamp={1}
              wordBreak="break-all"
            />
            {toTokenInfo?.Icon && (
              <toTokenInfo.Icon boxSize="16px" rounded="full" />
            )}
          </HStack>
          <UsdValue
            textStyle="body3"
            value={toTokenBalance}
            price={toTokenPrice}
          />
        </VStack>
      </HStack>
    </>
  );
};
